import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterCasinoReportView.
 * @extends JetView
 */
export default class FilterCasinoReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive behavior
                    cols: [
                        {
                            view: 'text', // Text input for date range selection
                            minWidth: 200,
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange', // CSS class for styling
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'), // Default date range
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the input
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Text input for user ID
                            name: 'transactionId',
                            type: 'text', // Input type is number
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('Tipo Transacción'), // Label for the input
                            css: 'prm-filterByUser', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Transacción'), // Placeholder text
                            invalidMessage: _('ID Transacción is required'), // Validation message
                        },
                        {
                            view: 'text', // Text input for user ID
                            name: 'UserId',
                            type: 'number', // Input type is number
                            minWidth: 200,
                            label: "<span class='icon-user'></span>" + _('ID Usuario Plataforma'), // Label for the input
                            css: 'prm-filterByUser', // CSS class for styling
                            labelPosition: 'top', // Position of the label
                            placeholder: _('ID Usuario Plataforma'), // Placeholder text
                            invalidMessage: _('ID Usuario is required'), // Validation message
                        },
                    ],
                },
            ],
        };
        const left3 = {
            margin: 5,
            id: 'a3',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a3', // Responsive behavior
                    cols: [
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'Country',
                            id: 'Country',
                            minWidth: 200,
                            localId: 'regions:combo', // Local ID for referencing
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the dropdown
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Custom template for displaying country flags
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for the dropdown
                                },
                            },
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'combo', // Combo box for ProviderId selection
                            name: 'ProviderId',
                            minWidth: 200,
                            label: _('Producto'), // Label for the combo box
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch ProviderId data
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/getProductsPoker',
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.clearAll(); // Clear previous options
                                                                vthis.parse(
                                                                    resp.data, // Populate with new data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo', // Combo box for supplier selection
                            name: 'Supplier',
                            minWidth: 200,
                            label: _('Proveedor'), // Label for the combo box
                            labelPosition: 'top', // Position of the label
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Function to fetch supplier data
                                        var vthis = this;
                                        if (text.length > 2) {
                                            // Fetch data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.clearAll(); // Clear previous options
                                                                vthis.parse(
                                                                    resp.Data, // Populate with new data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: "richselect",
                            label: _("Tipo de Reporte"),
                            labelPosition: "top",
                            name: "Type",
                            id: "Type",
                            placeholder: _("Click para seleccionar "),
                            options: [
                                { "id": '2', "value": _("Resumido por jugador") },
                                { "id": '1', "value": _("Resumido por proveedor") },
                            ],
                            minWidth: 200,
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section of the form
                },
                {
                    margin: 10,
                    cols: [left3], // Right section of the form
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('DateStart').setValue(''); // Clear start date
                        $$('DateEnd').setValue(''); // Clear end date
                    },
                },
                {
                    view: 'button', // Button to consult the report
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is configured
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date fields based on profile
                            delete filterdata['Date2'];
                        } else {
                            delete filterdata['DateStart'];
                            delete filterdata['DateEnd'];
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'), // Button label
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country selection
                        $$('DateStart').setValue(''); // Clear start date
                        $$('DateEnd').setValue(''); // Clear end date
                    },
                },
                {
                    view: 'button', // Button to consult the second form
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country if report is configured
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date fields based on profile
                            delete filterdata['Date2'];
                        } else {
                            if (true) {
                                delete filterdata['DateStart'];
                                delete filterdata['DateEnd'];
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]); // Trigger filter event
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide', // Type of the accordion
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for filters
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initial state of the accordion
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Content of the accordion
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the filters
            scroll: 'xy', // Scroll in both directions
            body: {
                padding: 10,
                rows: [upper_section], // Content of the scroll view
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true, // Allow moving the window
            id: 'filterPopup',
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Title label
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2',
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Content of the form
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            id: 'myForm',
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (screen.width < 500) {
                // Hide elements on small screens
                $$('grav2').hide();
                $$('grav3').hide();
            }
            if (profile.typeDate !== 2) {
                $$('Datepicker').show(); // Show datepicker based on profile
            } else {
                if (true) {
                    $$('Datepicker').hide(); // Hide datepicker if condition is met
                }
            }
        });
    }
}

// FILE DOCUMENTED
